import api from '../utils/api'; 
export const fetchLastUpdate = async () => {
  const response = await api.get('/update');
  return response.data;
};